export const REQUIREMENT_MODEL = "requirement";
export const COMPLIANCE_REQUIREMENT = "compliance-requirement";
export const OTHER_REQUIREMENT = "other-requirement";

const requirementModel = {
  name: ""
};

export default requirementModel;
